module.exports = __webpack_public_path__ + "img/katetrumpet.20d32a3d.png";